.modal {
    width: 600px;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    justify-content: space-between;
  }
  .modalContent {
    width: 100% !important;
    height: 100%;
    max-height: 100% !important;
    display: flex !important;
    flex-direction: column;
    row-gap: 12px;
    justify-content: space-between;
  }
  